import { defineStore } from 'pinia'
import { usageApi } from '@/api/modules/usage'
import { getApiConfig } from '@/config/api'
import { mockskillOverview, mockUsageRecords, mockInstalledSkills } from '@/mock'

const enableMock = getApiConfig().enableMock

export const useUsageStore = defineStore('usage', {
  state: () => ({
    records: [],
    installedSkills: [],
    filter: 'today',
    page: 1,
    total: 0,
    skillsOverview: {}
  }),

  actions: {
    async fetchRecords(filter = this.filter) {
      this.filter = filter
      try {
        if (enableMock) {
          this.records = mockUsageRecords
          this.total = mockUsageRecords.length
        } else {
          const data = await usageApi.getRecords({ timeRange: filter, page: this.page })
          this.records = data.list
          this.total = data.total
        }
      } catch {
        this.records = mockUsageRecords
        this.total = mockUsageRecords.length
      }
    },

    async fetchInstalledSkills() {
      try {
        if (enableMock) {
          this.installedSkills = mockInstalledSkills
        } else {
          const data = await usageApi.getInstalledSkills()
          this.installedSkills = data || []
        }
      } catch {
        this.installedSkills = mockInstalledSkills
      }
    },

    async fetchInstalledSkillsOverview() {
      try {
        if (enableMock) {
          this.skillsOverview = mockskillOverview
        } else {
          this.skillsOverview = await usageApi.getInstalledSkillsOverview()
        }
      } catch {
        this.skillsOverview = mockskillOverview
      }
    },

    loadMore() {
      this.page++
      this.fetchRecords()
    }
  }
})
